var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRealTimeAlerts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93249 30.4628C8.13138 30.8008 8.29999 31.0868 8.46878 31.373C8.63977 31.663 8.81094 31.9533 9.01372 32.2979H32.9863C33.1887 31.9541 33.3595 31.6643 33.5302 31.3749L33.5313 31.373C33.7001 31.0868 33.8687 30.8008 34.0676 30.4628L22.0796 9.38883H19.9205L7.93249 30.4628ZM18.8101 7.47974L5.72729 30.4784C6.21304 31.3061 6.51866 31.8244 6.82427 32.3427C7.12989 32.861 7.4355 33.3793 7.92125 34.207H34.0788C34.5645 33.3793 34.8701 32.861 35.1758 32.3427C35.4814 31.8244 35.787 31.3061 36.2727 30.4784L23.1899 7.47974H18.8101Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5681 16.6672H22.4317V25.2581H19.5681V16.6672Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5681 26.2126H22.4317V29.0763H19.5681V26.2126Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimeAlerts);
export default __webpack_public_path__ + "static/media/real-time-alerts.a3c042ca25505a028e18e16242a9db05.svg";
export { ForwardRef as ReactComponent };